import { fetchApi } from "@/api/base";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export type PriceAlertAction =
  | "any"
  | "increase"
  | "decrease"
  | "below_market";

export const useCreatePriceAlert = () => {
  const queryClient = useQueryClient();

  return useMutation({
    async mutationFn(data: {
      action: PriceAlertAction;
      price: number;
      cardId: number;
    }) {
      const response = await fetchApi("/api/price-alerts", {
        method: "POST",
        body: JSON.stringify(data),
      });

      return response;
    },
    async onSuccess(_, vars) {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ["price-alerts", vars.cardId],
        }),
        queryClient.invalidateQueries({
          queryKey: ["alerts"],
        }),
        queryClient.invalidateQueries({
          queryKey: ["notifications"],
        }),
      ]);
    },
  });
};
